import { Icons } from '../../../utils/Icons';

// Import existing admin pages
import Users from '../Users';
import Roles from '../Roles';
import Modules from '../Modules';
import Payment from '../Payment';

// Import placeholder components
import CultivationUnitList from '../../WatherRight/Config/CultivationUnit/CultivationUnitList';
import BreachTypeOfEvidenceList from '../../Fiscalizacion/Config/BreachTypeOfEvidence/BreachTypeOfEvidenceList';
import BreachRiskClassificationList from '../../Fiscalizacion/Config/BreachRiskClassification/BreachRiskClassificationList';
import BreachCategoryList from '../../Fiscalizacion/Config/BreachCategory/BreachCategoryList';
import DistanceUnitList from '../../WatherRight/Config/DistanceUnit/DistanceUnitList';
import DocumentTypeList from '../../WatherRight/Config/DocumentType/DocumentTypeList';
import FlowRateUnitList from '../../WatherRight/Config/FlowRateUnit/FlowRateUnitList';
import GeodeticDatumList from '../../WatherRight/Config/GeodeticDatum/GeodeticDatumList';
import InstallationLocationList from '../../WatherRight/Config/InstallationLocation/InstallationLocationList';
import MeasurementFrequencyList from '../../WatherRight/Config/MeasurementFrequency/MeasurementFrequencyList';
import ProcedureTypeList from '../../WatherRight/Config/ProcedureType/ProcedureTypeList';
import RealEstateRegistryList from '../../WatherRight/Config/RealEstateRegistry/RealEstateRegistryList';
import ReportingFrequencyList from '../../WatherRight/Config/ReportingFrequency/ReportingFrequencyList';
import ReportingStatusList from '../../WatherRight/Config/ReportingStatus/ReportingStatusList';
import ReportingTypeList from '../../WatherRight/Config/ReportingType/ReportingTypeList';
import RightExerciseTypeList from '../../WatherRight/Config/RightExerciseType/RightExerciseTypeList';
import UtmZoneList from '../../WatherRight/Config/UtmZone/UtmZoneList';
import WaterRightsStatusList from '../../WatherRight/Config/WaterRightsStatus/WaterRightsStatusList';
import WaterRightTypeList from '../../WatherRight/Config/WaterRightType/WaterRightTypeList';
import WaterSourceList from '../../WatherRight/Config/WaterSource/WaterSourceList';
import WaterSourceTypeList from '../../WatherRight/Config/WaterSourceType/WaterSourceTypeList';
import WaterUseStatusList from '../../WatherRight/Config/WaterUseStatus/WaterUseStatusList';
import WaterUseTypeList from '../../WatherRight/Config/WaterUseType/WaterUseTypeList';
import WorkOrderStatusList from '../../WatherRight/Config/WorkOrderStatus/WorkOrderStatusList';
import WorkStatusList from '../../WatherRight/Config/WorkStatus/WorkStatusList';
import WRPositionList from '../../WatherRight/Config/WRPosition/WRPositionList';

// Configuración de maestros organizada por categorías
export const MastersCategoriesConfig = [
	{
	    label: 'Medio Ambiente',    
		id: 'environment',
		masters: [
            {
                id: 'distance-unit',
                label: 'Unidad de Distancia',
                icon: Icons.gauge,
                component: DistanceUnitList,
                category: 'environment',
            },
            {
                id: 'position',
                label: 'Posición',
                icon: Icons.activity,
                component: WRPositionList,
                category: 'environment',
            },
            {
                id: 'document-type',
                label: 'Tipo de Documento',
                icon: Icons.document,
                component: DocumentTypeList,
                category: 'environment',
            },
            {
                id: 'flow-rate-unit',
                label: 'Unidad de Medida',
                icon: Icons.ruler,
                component: FlowRateUnitList,
                category: 'environment',
            },
            {
                id: 'geodetic-datum',
                label: 'Datum Geodésico',
                icon: Icons.compass,
                component: GeodeticDatumList,   
                category: 'environment',
            },
            {
                id: 'installation-location',
                label: 'Ubicación de Instalación',
                icon: Icons.mapPin,
                component: InstallationLocationList,
                category: 'environment',
            },
            {
                id: 'measurement-unit',
                label: 'Frecuencia de Medición',
                icon: Icons.gauge,
                component: MeasurementFrequencyList,
                category: 'environment',
            },
            {
                id: 'procedure-type',
                label: 'Tipo de Tramite',
                icon: Icons.fileText,
                component: ProcedureTypeList,
                category: 'environment',
            },
            {
                id: 'real-estate-registry',
                label: 'Conservador de Bienes Raíces',
                icon: Icons.landmark,
                component: RealEstateRegistryList,
                category: 'environment',
            },
            {
                id: 'reporting-frequency',
                label: 'Frecuencia de Reportabilidad',
                icon: Icons.gauge,
                component: ReportingFrequencyList,
                category: 'environment',
            },
            {
                id: 'reporting-status',
                label: 'Condición de Reportabilidad',
                icon: Icons.activity,
                component: ReportingStatusList,
                category: 'environment',
            },
            {
                id: 'reporting-type',
                label: 'Tipo de Reportabilidad',
                icon: Icons.tags,
                component: ReportingTypeList,
                category: 'environment',
            },
            {
                id: 'right-exercise-type',
                label: 'Ejercicio de Derecho',
                icon: Icons.zap,
                component: RightExerciseTypeList,
                category: 'environment',
            },
            {
                id: 'utm-zone',
                label: 'Zona UTM',
                icon: Icons.map,
                component: UtmZoneList,
                category: 'environment',
            },
            {
                id: 'water-rights-status',
                label: 'Estado de Derecho de Agua',
                icon: Icons.fileBadge,
                component: WaterRightsStatusList,
                category: 'environment',
            },
            {
                id: 'water-right-type',
                label: 'Tipo de Derecho',
                icon: Icons.fileBadge,
                component: WaterRightTypeList,
                category: 'environment',
            },
            {
                id: 'water-source',
                label: 'Fuente',
                icon: Icons.water,
                component: WaterSourceList,
                category: 'environment',
            },
            {
                id: 'water-source-type',
                label: 'Clasificación de la Naturaleza del Agua',
                icon: Icons.tags,
                component: WaterSourceTypeList,
                category: 'environment',
            },
            {
                id: 'water-use-status',
                label: 'Estado de Uso',
                icon: Icons.toggleLeft,
                component: WaterUseStatusList,
                category: 'environment',
            },
            {
                id: 'water-use-type',
                label: 'Uso del Agua',
                icon: Icons.tags,
                component: WaterUseTypeList,
                category: 'environment',
            },
            {
                id: 'work-order-status',
                label: 'Estado de Obra',
                icon: Icons.toggleRight,
                component: WorkOrderStatusList,
                category: 'environment',
            },
            {
                id: 'work-status',
                label: 'Estado de Actividad',
                icon: Icons.toggleRight,
                component: WorkStatusList,
                category: 'environment',
            }
			
		]
	},
    {
        label: 'Normativa',
        id: 'normative',
        masters: [
            {
                id: 'breach-type-of-evidence',
                label: 'Tipo de Evidencia',
                icon: Icons.document,
                component: BreachTypeOfEvidenceList,
                category: 'normative'
            },
            {
                id: 'breach-risk-classification',
                label: 'Clasificación de Riesgo',
                icon: Icons.tags,
                component: BreachRiskClassificationList,
                category: 'normative'
            },
            {
                id: 'breach-category',
                label: 'Categoría de Incumplimiento',
                icon: Icons.tags,
                component: BreachCategoryList,
                category: 'normative'
            }
        ]
    }
	
];

// Lista plana de todos los maestros (para compatibilidad)
export const MastersConfig = MastersCategoriesConfig.flatMap(category => category.masters);
